import React from 'react';
import { Snackbar, Alert as MuiAlert, AlertColor } from '@mui/material'; // Renamed Alert to MuiAlert to avoid conflict if any
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { hideNotification } from '../../redux/features/notificationSlice';

const GlobalNotification: React.FC = () => {
  const dispatch = useAppDispatch();
  // Ensure the state slice is named 'notification' in your root reducer
  const { open, message, severity, duration } = useAppSelector((state) => state.notification);

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(hideNotification());
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 200 }} // Ensure it's above other elements like drawers
    >
      <MuiAlert onClose={handleClose} severity={severity as AlertColor} sx={{ width: '100%' }} variant="filled" elevation={6}>
        {message}
      </MuiAlert>
    </Snackbar>
  );
};

export default GlobalNotification;
